module.exports = __webpack_public_path__ + "static/img/Ajdin-Hrustic.fb3c893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ajdin-Hrustic.jpg
// module id = jwye
// module chunks = 0